<template>
  <div class="crud_form_wrapper">
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.view_patient") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #233076">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>

    <div class="single_step_form_content_wrapper">
      <form>
        <div class="row">
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.name')"
            v-model.trim="data.name"
            disabled
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.diagnosis')"
            v-model.trim="data.diagnosis"
            disabled
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.phone')"
            v-model.trim="data.phone"
            disabled
          />
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShowPatient",

  data() {
    return {
      data: {
        name: null,
        diagnosis: null,
        phone: null,
      },
    };
  },

  methods: {
    async getData() {
      try {
        const res = await this.$axios({
          method: "GET",
          url: `patients/${this.$route.params.id}`,
        });
        const item = res.data?.data?.Patient || {};
        this.data.name = item.name;
        this.data.diagnosis = item.diagnosis;
        this.data.phone = item.phone;
      } catch (error) {
        this.$message.error(
          error?.response?.data?.message || "Failed to load patient details"
        );
      }
    },
  },

  created() {
    this.getData();
  },
};
</script>
